import { servicesList } from "constants/services";
import * as api from "../API/index";
import { authorizedUser } from "components/Common/commonFunctions";

//Get Services List
export const getServiceList = async (
  dispatch,
  pageNum,
  filters,
  searchString
) => {
  try {
    const res = await api.service_list(pageNum, filters, searchString);
    dispatch({ type: servicesList, payload: res.data });
  } catch (error) {
    dispatch({ type: servicesList, payload: error?.response?.data || error });
    authorizedUser(error.response?.data);
  }
};

//Get Service by id
export const getServiceByID = async (id) => {
  try {
    const res = await api.get_service_by_ID(id);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

//Add Service
export const addService = async (bodyData) => {
  try {
    const res = await api.add_service(bodyData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

//Edit Service
export const editService = async (id, bodyData) => {
  try {
    const res = await api.edit_service(id, bodyData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

// export services
export const exportServicesCSV = async ({ filters, searchString } = {}) => {
  try {
    const res = await api.export_services(filters, searchString);
    return res;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};